import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Navigation {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-nav',
            rootToggleAttr: 'rootToggle',
            scrollerAttr: 'scroller',
            toggleAttr: 'toggle',
            closeAttr: 'close',
            breakpoint: 1280
        };

        this.settings = Object.assign({}, defaults, options);

        this.$navigation = element;
        this.$navigationToggle = document.querySelector('[' + this.settings.initAttr + '="' + this.settings.rootToggleAttr + '"]');
        this.$navigationScroller = this.$navigation.querySelector('[' + this.settings.initAttr + '="' + this.settings.scrollerAttr + '"]');
        this.$navigationToggles = this.$navigation.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.$navigationMainWithChildren = this.$navigation.querySelectorAll('.main-nav__list-item.has--children');
        this.$body = document.querySelector('body');
        this.closeTimers = new Map();

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        const breakpoint = window.matchMedia('(min-width: ' + this.settings.breakpoint + 'px)');

        breakpoint.addEventListener('change', (e) => {
            if (e.matches) {
                enableBodyScroll(this.$navigationScroller);
            } else if (this.$navigationToggle.checked === true) {
                disableBodyScroll(this.$navigationScroller);
            }
        });

        this.$navigation.addEventListener('change', (e) => {
            const $element = e.target;

            if ($element === this.$navigationToggle) {
                if (this.$navigationToggle.checked === true) {
                    this.clearAllSubnavs();
                    window.innerWidth <= this.settings.breakpoint && disableBodyScroll(this.$navigationScroller);
                } else {
                    window.innerWidth <= this.settings.breakpoint && enableBodyScroll(this.$navigationScroller);
                }
            }

            if ($element.getAttribute(this.settings.initAttr) === this.settings.toggleAttr) {
                this.$navigationScroller.scrollTo(0, 0);
            }
        });

        for (let i = 0; i < this.$navigationMainWithChildren.length; i++) {
            const $rootItem = this.$navigationMainWithChildren[i];
            const $closeSubnavHandle = $rootItem.querySelector('[' + this.settings.initAttr + '="' + this.settings.closeAttr + '"]');

            $rootItem.addEventListener('mouseenter', () => {
                if (breakpoint.matches) {
                    this.$body.classList.add('nav--open');
                    window.innerWidth <= this.settings.breakpoint && disableBodyScroll(this.$navigationScroller);
                }
            });

            $rootItem.addEventListener('mouseleave', () => {
                if (breakpoint.matches) {
                    this.$body.classList.remove('nav--open');
                    this.clearAllSubnavs();
                    window.innerWidth <= this.settings.breakpoint && enableBodyScroll(this.$navigationScroller);
                }
            });

            if ($closeSubnavHandle) {
                $closeSubnavHandle.addEventListener('click', (e) => {
                    if (breakpoint.matches) {
                        this.$body.classList.remove('nav--open');
                        this.closeMainnav($rootItem);
                    }
                });
            }
        }

        document.addEventListener('click', (e) => {
            if (breakpoint.matches && e.target.classList.contains('sub-nav')) {
                const $rootItem = e.target.closest('.main-nav__list-item.has--children');
                this.closeMainnav($rootItem);
            }
        });

        window.eventScroller.customFunctions.push(() => {
            if (breakpoint.matches) {
                if (this.$body.classList.contains('nav--open')) {
                    this.$navigationMainWithChildren.forEach($navigationMainWithChild => {
                        this.closeMainnav($navigationMainWithChild);
                    });

                    window.setTimeout(() => {
                        this.$body.classList.remove('nav--open');
                    }, 500);
                }
            }
        });
    }

    closeMainnav ($item) {
        const existingTimer = this.closeTimers.get($item);
        if (existingTimer) {
            clearTimeout(existingTimer);
        }

        $item.classList.add('inactive');

        const timer = window.setTimeout(() => {
            $item.classList.remove('inactive');
            this.closeTimers.delete($item);
        }, 1000);

        this.closeTimers.set($item, timer);
    }

    clearAllSubnavs () {
        for (let i = 0; i < this.$navigationToggles.length; i++) {
            const $toggle = this.$navigationToggles[i];

            if ($toggle.checked === true) {
                $toggle.checked = false;
            }
        }
    }
}

export default Navigation;
